import React, { useState, useEffect, useRef, useCallback } from 'react';

const DOC_TYPES = [
  {
    id: 'petition', label: 'Petition / Plaint', icon: '📋',
    fields: [
      { key: 'courtName',          label: 'Court Name',              placeholder: 'High Court of Andhra Pradesh at Amaravathi' },
      { key: 'caseType',           label: 'Type of Case',            placeholder: 'Writ Petition', type: 'select', options: ['Writ Petition','Civil Petition','Criminal Petition','Original Petition','Appeal','Revision'] },
      { key: 'petitionerName',     label: 'Petitioner Name',         placeholder: 'Full name' },
      { key: 'petitionerAddress',  label: 'Petitioner Address',      placeholder: 'Complete address', type: 'textarea' },
      { key: 'respondentName',     label: 'Respondent Name',         placeholder: 'Full name / designation' },
      { key: 'respondentAddress',  label: 'Respondent Address',      placeholder: 'Complete address', type: 'textarea' },
      { key: 'background',         label: 'Background / Facts',      placeholder: 'Describe the background and facts of your case...', type: 'textarea' },
      { key: 'reliefSought',       label: 'Relief Sought',           placeholder: 'What are you asking the court to do?', type: 'textarea' },
      { key: 'grounds',            label: 'Grounds',                 placeholder: 'Legal grounds for filing...', type: 'textarea' },
    ],
  },
  {
    id: 'vakalatnama', label: 'Vakalatnama', icon: '✍️',
    fields: [
      { key: 'clientName',     label: 'Client Name',            placeholder: 'Full name of the client' },
      { key: 'clientAddress',  label: 'Client Address',         placeholder: 'Complete address', type: 'textarea' },
      { key: 'advocateName',   label: 'Advocate Name',          placeholder: 'Full name' },
      { key: 'enrollmentNo',   label: 'Enrollment Number',      placeholder: 'Bar Council enrollment no.' },
      { key: 'courtName',      label: 'Court Name',             placeholder: 'High Court of Andhra Pradesh at Amaravathi' },
      { key: 'caseTitle',      label: 'Case Title / Description', placeholder: 'Brief description of the case' },
      { key: 'date',           label: 'Date',                   placeholder: 'e.g. 23rd April 2026' },
    ],
  },
  {
    id: 'affidavit', label: 'Affidavit', icon: '📜',
    fields: [
      { key: 'deponentName',  label: 'Deponent Name',              placeholder: 'Full name' },
      { key: 'age',           label: 'Age',                        placeholder: 'Age in years' },
      { key: 'occupation',    label: 'Occupation',                 placeholder: 'e.g. Software Engineer' },
      { key: 'fatherName',    label: "Father's / Husband's Name",  placeholder: 'Full name' },
      { key: 'address',       label: 'Address',                    placeholder: 'Complete residential address', type: 'textarea' },
      { key: 'purpose',       label: 'Purpose of Affidavit',       placeholder: 'e.g. In support of Writ Petition' },
      { key: 'facts',         label: 'Statement of Facts',         placeholder: 'State the facts you are swearing to...', type: 'textarea' },
      { key: 'place',         label: 'Place',                      placeholder: 'e.g. Hyderabad / Amaravathi' },
      { key: 'date',          label: 'Date',                       placeholder: 'e.g. 23rd April 2026' },
    ],
  },
  {
    id: 'memo-of-parties', label: 'Memo of Parties', icon: '👥',
    fields: [
      { key: 'petitionerName',       label: 'Petitioner Full Name',         placeholder: 'Full name' },
      { key: 'petitionerAge',        label: 'Petitioner Age',               placeholder: 'Age' },
      { key: 'petitionerOccupation', label: 'Petitioner Occupation',        placeholder: 'Occupation' },
      { key: 'petitionerAddress',    label: 'Petitioner Address',           placeholder: 'Complete address', type: 'textarea' },
      { key: 'petitionerPhone',      label: 'Petitioner Phone / Email',     placeholder: 'Contact details' },
      { key: 'respondentName',       label: 'Respondent Name / Designation',placeholder: 'Full name and designation' },
      { key: 'respondentAddress',    label: 'Respondent Address',           placeholder: 'Complete address', type: 'textarea' },
      { key: 'respondentPhone',      label: 'Respondent Phone / Email',     placeholder: 'Contact (if known)' },
      { key: 'caseType',             label: 'Type of Case',                 placeholder: 'e.g. Writ Petition' },
    ],
  },
  {
    id: 'cause-title', label: 'Cause Title', icon: '⚖️',
    fields: [
      { key: 'courtName',              label: 'Court Name',                    placeholder: 'High Court of Andhra Pradesh at Amaravathi' },
      { key: 'caseType',              label: 'Case Type',                     placeholder: 'e.g. Writ Petition' },
      { key: 'caseNumber',            label: 'Case Number (if assigned)',      placeholder: 'Leave blank if not yet assigned' },
      { key: 'year',                  label: 'Year',                          placeholder: 'e.g. 2026' },
      { key: 'petitionerName',        label: 'Petitioner Name',               placeholder: 'Full name' },
      { key: 'petitionerDesignation', label: 'Petitioner Designation',        placeholder: 'e.g. Proprietor / Resident of' },
      { key: 'respondentName',        label: 'Respondent Name',               placeholder: 'Full name / designation' },
      { key: 'respondentCapacity',    label: 'Respondent Capacity',           placeholder: 'e.g. State of A.P. rep. by Secretary' },
    ],
  },
  {
    id: 'supporting-docs', label: 'Supporting Documents', icon: '📁',
    fields: [
      { key: 'petitionerName', label: 'Petitioner Name',    placeholder: 'Full name' },
      { key: 'caseTitle',      label: 'Case Title',         placeholder: 'Brief case description' },
      { key: 'courtName',      label: 'Court Name',         placeholder: 'High Court of Andhra Pradesh at Amaravathi' },
      { key: 'documentList',   label: 'List of Documents',  placeholder: '1. Copy of Agreement dated 01-01-2025\n2. Aadhar Card\n3. Bank Statement', type: 'textarea' },
      { key: 'date',           label: 'Date',               placeholder: 'e.g. 23rd April 2026' },
    ],
  },
];

function downloadLegalDoc(text) {
  const escaped = text.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/\n/g,'<br>');
  const w = window.open('', '_blank', 'width=820,height=700');
  w.document.write(`<!DOCTYPE html><html><head><title>Legal Draft — Axigon</title><style>
    body{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;max-width:680px;margin:40px auto;color:#111;line-height:1.8;font-size:14px}
    h1{font-size:20px;margin:0 0 4px}p.sub{color:#999;font-size:12px;margin:0 0 28px}
    .content{white-space:pre-wrap;line-height:1.9}
    .footer{margin-top:40px;font-size:11px;color:#bbb;border-top:1px solid #eee;padding-top:14px}
    button{position:fixed;top:16px;right:16px;padding:8px 18px;background:#111;color:#fff;border:none;border-radius:6px;cursor:pointer;font-size:13px}
    @media print{button{display:none}}
  </style></head><body>
  <h1>Legal Draft</h1><p class="sub">Generated by Axigon Legal GPT · Indian Law</p>
  <div class="content">${escaped}</div>
  <div class="footer">AI-generated guidance based on Indian law. Consult a qualified lawyer before use.</div>
  <button onclick="window.print()">Download PDF</button>
  </body></html>`);
  w.document.close();
}

/*
  LegalGPT — full Legal GPT page extracted from App.js.
  Props:
    user             — current user object
    navigateTo       — navigation helper
    goBack           — back navigation helper
    legalFirstTime   — bool, set from outside (dashboard tile / welcome page)
    setLegalFirstTime — setter for the above
*/
const JURISDICTION_OPTIONS = [
  'Andhra Pradesh High Court',
  'Telangana High Court',
  'Delhi High Court',
  'Bombay High Court',
  'Karnataka High Court',
  'Madras High Court',
  'Other / General',
];

const LegalGPT = ({ user, navigateTo, goBack, legalFirstTime, setLegalFirstTime }) => {
  const [legalMessages, setLegalMessages] = useState([]);
  const [legalInput, setLegalInput] = useState('');
  const [legalLoading, setLegalLoading] = useState(false);
  const [legalConversations, setLegalConversations] = useState([]);
  const [legalConversationId, setLegalConversationId] = useState(null);
  const [legalConvsLoading, setLegalConvsLoading] = useState(false);
  const [legalMessagesLoading, setLegalMessagesLoading] = useState(false);
  const [legalChatError, setLegalChatError] = useState('');
  const [legalDeleteConfirm, setLegalDeleteConfirm] = useState(null);
  const [copiedMsg, setCopiedMsg] = useState(null);
  const [docType, setDocType] = useState(null);
  const [docStep, setDocStep] = useState('form');
  const [docFields, setDocFields] = useState({});
  const [docResult, setDocResult] = useState('');
  const [docError, setDocError] = useState('');
  const [docCopied, setDocCopied] = useState(false);
  const [jurisdiction, setJurisdiction] = useState('Andhra Pradesh High Court');
  const [disclaimerDismissed, setDisclaimerDismissed] = useState(
    () => typeof window !== 'undefined' && localStorage.getItem('axigon_legal_disclaimer_dismissed') === '1'
  );

  const legalChatRef = useRef(null);

  const copyMsg = useCallback((text, i) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedMsg(i);
      setTimeout(() => setCopiedMsg(null), 2000);
    });
  }, []);

  const relativeDate = (d) => {
    const date = new Date(d);
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const target = new Date(date); target.setHours(0, 0, 0, 0);
    const diff = Math.floor((today - target) / 86400000);
    if (diff === 0) return 'Today';
    if (diff === 1) return 'Yesterday';
    return date.toLocaleDateString('en-IN', { month: 'short', day: 'numeric' });
  };

  const fetchLegalConversations = async () => {
    setLegalConvsLoading(true);
    try {
      const res = await fetch('/api/legal?action=conversations', { credentials: 'include' });
      if (res.ok) {
        const data = await res.json();
        setLegalConversations(data.conversations || []);
      }
    } catch {}
    setLegalConvsLoading(false);
  };

  const handleLegalDeleteConversation = async (convId) => {
    try {
      const res = await fetch('/api/legal?action=delete-conversation', {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ conversationId: convId }),
      });
      if (res.ok) {
        setLegalConversations(prev => prev.filter(c => c._id !== convId));
        if (legalConversationId === convId) {
          setLegalConversationId(null);
          setLegalMessages([]);
        }
      }
    } catch {}
    setLegalDeleteConfirm(null);
  };

  const handleLegalSend = async (e, forcedMsg) => {
    if (e && e.preventDefault) e.preventDefault();
    const msg = forcedMsg || legalInput.trim();
    if (!msg || legalLoading) return;

    setLegalMessages(prev => [...prev, { role: 'user', text: msg }]);
    setLegalInput('');
    setLegalLoading(true);
    setLegalChatError('');
    setLegalFirstTime(false);

    try {
      const res = await fetch('/api/legal?action=chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ message: msg, conversationId: legalConversationId }),
      });
      if (!res.ok) throw new Error('Request failed');
      const data = await res.json();
      const reply = data.response || 'No response received.';
      if (data.conversationId) setLegalConversationId(data.conversationId);
      setLegalMessages(prev => [...prev, { role: 'assistant', text: reply }]);
      fetchLegalConversations();
    } catch {
      setLegalChatError('Failed to get a response. Please try again.');
    } finally {
      setLegalLoading(false);
    }
  };

  const handleGenerateDoc = async (e) => {
    e.preventDefault();
    setDocError('');
    setDocStep('generating');
    try {
      const res = await fetch('/api/legal?action=generate-doc', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ docType, fields: docFields, jurisdiction }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Generation failed');
      setDocResult(data.document);
      setDocStep('result');
    } catch (err) {
      setDocError(err.message);
      setDocStep('form');
    }
  };

  // Fetch conversations on mount
  useEffect(() => {
    fetchLegalConversations();
  }, []);

  // Inject first-time greeting
  useEffect(() => {
    if (legalFirstTime && legalMessages.length === 0) {
      const firstName = user?.name?.split(' ')[0] || 'there';
      setLegalMessages([{
        role: 'assistant',
        text: `Hi ${firstName}, I am Axigon Legal Guidance — providing educational information on Indian law to help you understand your rights and options. I can help you understand contracts, GST notices, employment agreements, rent disputes, property documents, and general legal questions. I will always recommend consulting a licensed advocate before taking any legal action. What would you like to understand?`,
      }]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [legalFirstTime]);

  // Auto-scroll to bottom on new messages
  useEffect(() => {
    if (legalChatRef.current) legalChatRef.current.scrollTop = legalChatRef.current.scrollHeight;
  }, [legalMessages, legalLoading]);

  // Auto-dismiss error bar after 4s
  useEffect(() => {
    if (!legalChatError) return;
    const t = setTimeout(() => setLegalChatError(''), 4000);
    return () => clearTimeout(t);
  }, [legalChatError]);

  return (
    <section style={{ minHeight: '100vh', backgroundColor: 'var(--bg)', paddingTop: '64px', display: 'flex', flexDirection: 'column' }}>

      {/* ── Disclaimer Banner ── */}
      {!disclaimerDismissed && (
        <div style={{ backgroundColor: 'rgba(251,191,36,0.1)', border: '1px solid rgba(251,191,36,0.3)', borderRadius: '0', padding: '10px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', flexShrink: 0 }}>
          <span style={{ fontSize: '12px', color: 'var(--text-secondary)', lineHeight: 1.5 }}>
            <strong style={{ color: 'var(--text-primary)' }}>Educational information only.</strong> Axigon provides educational information to help you understand your rights and options. This is not legal advice. Always consult a licensed advocate before taking any legal action.
          </span>
          <button
            onClick={() => { setDisclaimerDismissed(true); localStorage.setItem('axigon_legal_disclaimer_dismissed', '1'); }}
            style={{ background: 'none', border: 'none', color: 'var(--text-tertiary)', cursor: 'pointer', fontSize: '16px', lineHeight: 1, padding: '0 4px', fontFamily: 'inherit', flexShrink: 0 }}
          >×</button>
        </div>
      )}

      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>

      {/* ── Sidebar ── */}
      <div style={{ width: '250px', flexShrink: 0, backgroundColor: 'var(--bg-secondary)', borderRight: '1px solid var(--border)', display: 'flex', flexDirection: 'column', height: disclaimerDismissed ? 'calc(100vh - 64px)' : 'calc(100vh - 106px)', position: 'sticky', top: disclaimerDismissed ? '64px' : '106px' }}>

        {/* Sidebar header */}
        <div style={{ padding: '20px 16px 12px', borderBottom: '1px solid var(--border)' }}>
          <button
            onClick={() => goBack()}
            style={{ background: 'none', border: 'none', color: 'var(--text-tertiary)', fontSize: '13px', fontWeight: 500, cursor: 'pointer', padding: 0, marginBottom: '48px', fontFamily: 'inherit', transition: 'color 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.color = 'var(--text-primary)'}
            onMouseLeave={e => e.currentTarget.style.color = 'var(--text-tertiary)'}
          >← Back</button>
          <div style={{ marginBottom: '4px' }}>
            <span style={{ fontSize: '16px', fontWeight: 800, color: 'var(--text-primary)' }}>Legal </span>
            <span style={{ fontSize: '16px', fontWeight: 800, background: 'linear-gradient(135deg, var(--accent), var(--accent))', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Guidance</span>
          </div>
          <button
            onClick={() => {
              if (legalConversationId) {
                fetch('/api/finance?action=update-context', {
                  method: 'POST', credentials: 'include',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ conversationId: legalConversationId, agentType: 'legal' }),
                }).catch(() => {});
              }
              setLegalMessages([]); setLegalConversationId(null); setLegalInput('');
            }}
            style={{ width: '100%', marginTop: '12px', padding: '9px', borderRadius: '8px', background: 'var(--accent)', color: 'white', border: 'none', fontWeight: 700, fontSize: '13px', cursor: 'pointer', transition: 'opacity 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
          >+ New Chat</button>
        </div>

        {/* Conversation list */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '8px', minHeight: 0 }}>
          {legalConvsLoading && (
            <>
              {[1, 2, 3].map(i => (
                <div key={i} style={{ padding: '10px 12px', borderRadius: '8px', marginBottom: '2px' }}>
                  <div style={{ height: '11px', borderRadius: '4px', backgroundColor: 'var(--border)', marginBottom: '6px', width: `${60 + i * 10}%` }} />
                  <div style={{ height: '9px', borderRadius: '4px', backgroundColor: '#12202E', width: '40%' }} />
                </div>
              ))}
            </>
          )}
          {!legalConvsLoading && legalConversations.length === 0 && (
            <p style={{ color: '#2D3F55', fontSize: '12px', textAlign: 'center', marginTop: '24px', padding: '0 8px', lineHeight: 1.6 }}>No conversations yet.<br />Ask a legal question to get started.</p>
          )}
          {!legalConvsLoading && legalConversations.map(conv => {
            const isActive = legalConversationId === conv._id;
            const isConfirming = legalDeleteConfirm === conv._id;
            const date = relativeDate(conv.updatedAt || conv.createdAt);
            return (
              <div key={conv._id} style={{ position: 'relative', marginBottom: '2px' }}
                onMouseEnter={e => { const btn = e.currentTarget.querySelector('.del-btn'); if (btn) btn.style.opacity = '1'; }}
                onMouseLeave={e => { const btn = e.currentTarget.querySelector('.del-btn'); if (btn && !isConfirming) btn.style.opacity = '0'; }}
              >
                {isConfirming ? (
                  <div style={{ padding: '8px 12px', borderRadius: '8px', backgroundColor: 'rgba(244,63,94,0.1)', border: '1px solid rgba(244,63,94,0.25)' }}>
                    <p style={{ fontSize: '12px', color: 'var(--text-primary)', marginBottom: '8px' }}>Delete this conversation?</p>
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <button onClick={() => handleLegalDeleteConversation(conv._id)}
                        style={{ flex: 1, padding: '5px', borderRadius: '5px', background: '#F43F5E', color: 'white', border: 'none', fontSize: '12px', fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Yes</button>
                      <button onClick={() => setLegalDeleteConfirm(null)}
                        style={{ flex: 1, padding: '5px', borderRadius: '5px', background: 'var(--border)', color: 'var(--text-secondary)', border: 'none', fontSize: '12px', fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>No</button>
                    </div>
                  </div>
                ) : (
                  <button
                    onClick={async () => {
                      setLegalConversationId(conv._id);
                      setLegalMessagesLoading(true);
                      try {
                        const res = await fetch(`/api/legal?action=messages&conversationId=${conv._id}`, { credentials: 'include' });
                        const data = await res.json();
                        setLegalMessages((data.messages || []).map(m => ({ role: m.role, text: m.content })));
                      } catch {}
                      setLegalMessagesLoading(false);
                    }}
                    style={{ width: '100%', textAlign: 'left', padding: '10px 12px', borderRadius: '8px', border: 'none', backgroundColor: isActive ? 'rgba(0,194,124,0.12)' : 'transparent', cursor: 'pointer', transition: 'background-color 0.15s', outline: isActive ? '1px solid rgba(139,92,246,0.35)' : 'none', paddingRight: '28px', fontFamily: 'inherit' }}
                    onMouseEnter={e => { if (!isActive) e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.04)'; }}
                    onMouseLeave={e => { if (!isActive) e.currentTarget.style.backgroundColor = 'transparent'; }}
                  >
                    <div style={{ fontSize: '13px', fontWeight: 500, color: isActive ? '#C4B5FD' : 'var(--text-secondary)', marginBottom: '3px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {conv.title.length > 35 ? conv.title.slice(0, 35) + '…' : conv.title}
                    </div>
                    <div style={{ fontSize: '11px', color: '#2D3F55' }}>{date}</div>
                  </button>
                )}
                {!isConfirming && (
                  <button className="del-btn"
                    onClick={e => { e.stopPropagation(); setLegalDeleteConfirm(conv._id); }}
                    style={{ position: 'absolute', top: '50%', right: '6px', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#4B6279', fontSize: '14px', cursor: 'pointer', padding: '2px 5px', borderRadius: '4px', opacity: 0, transition: 'opacity 0.15s, color 0.15s', fontFamily: 'inherit', lineHeight: 1 }}
                    onMouseEnter={e => e.currentTarget.style.color = '#F43F5E'}
                    onMouseLeave={e => e.currentTarget.style.color = '#4B6279'}
                  >×</button>
                )}
              </div>
            );
          })}
        </div>
        {/* Legal Document Templates */}
        <div style={{ borderTop: '1px solid var(--border)', padding: '12px 10px', flexShrink: 0 }}>
          <p style={{ fontSize: '10px', fontWeight: 700, color: 'var(--text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.1em', margin: '0 0 8px', padding: '0 4px' }}>Legal Documents</p>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}>
            {DOC_TYPES.map(dt => (
              <button
                key={dt.id}
                onClick={() => { setDocType(dt.id); setDocStep('form'); setDocFields({}); setDocResult(''); setDocError(''); }}
                style={{
                  background: docType === dt.id ? 'rgba(0,194,124,0.12)' : 'var(--bg-secondary)',
                  border: `1px solid ${docType === dt.id ? 'rgba(139,92,246,0.4)' : 'var(--border)'}`,
                  borderRadius: '7px', padding: '7px 6px', cursor: 'pointer', textAlign: 'center',
                  fontFamily: 'inherit', transition: 'all 0.15s',
                }}
                onMouseEnter={e => { if (docType !== dt.id) { e.currentTarget.style.borderColor = 'rgba(139,92,246,0.3)'; e.currentTarget.style.background = 'rgba(139,92,246,0.06)'; } }}
                onMouseLeave={e => { if (docType !== dt.id) { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.background = 'var(--bg-secondary)'; } }}
              >
                <span style={{ display: 'block', fontSize: '14px', marginBottom: '3px' }}>{dt.icon}</span>
                <span style={{ fontSize: '10px', color: docType === dt.id ? '#C4B5FD' : 'var(--text-secondary)', fontWeight: 600, lineHeight: 1.3, display: 'block' }}>{dt.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* ── Document Generator Panel ── */}
      {docType && (() => {
        const dt = DOC_TYPES.find(d => d.id === docType);
        const iStyle = { width: '100%', padding: '10px 13px', borderRadius: '8px', border: '1px solid var(--border)', backgroundColor: 'var(--bg-secondary)', color: 'var(--text-primary)', fontSize: '13px', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' };
        const lStyle = { fontSize: '11px', fontWeight: 600, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.07em', display: 'block', marginBottom: '5px' };

        return (
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: 'calc(100vh - 64px)', overflow: 'hidden' }}>
            {/* Header */}
            <div style={{ padding: '16px 24px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0 }}>
              <button onClick={() => setDocType(null)} style={{ background: 'none', border: 'none', color: 'var(--text-tertiary)', fontSize: '13px', cursor: 'pointer', fontFamily: 'inherit', padding: 0 }}>← Back to chat</button>
              <span style={{ color: 'var(--border)' }}>|</span>
              <span style={{ fontSize: '15px', fontWeight: 700, color: 'var(--text-primary)' }}>{dt.icon} {dt.label}</span>
              {docStep === 'result' && (
                <button onClick={() => { setDocStep('form'); setDocResult(''); }} style={{ marginLeft: 'auto', background: 'transparent', border: '1px solid var(--border)', color: 'var(--text-secondary)', borderRadius: '6px', padding: '5px 12px', fontSize: '12px', cursor: 'pointer', fontFamily: 'inherit' }}>Edit details</button>
              )}
            </div>

            <div style={{ flex: 1, overflowY: 'auto', padding: '24px 32px' }}>

              {/* Generating spinner */}
              {docStep === 'generating' && (
                <div style={{ textAlign: 'center', marginTop: '80px' }}>
                  <div style={{ width: '44px', height: '44px', border: '3px solid var(--border)', borderTopColor: 'var(--accent)', borderRadius: '50%', animation: 'spin 0.9s linear infinite', margin: '0 auto 16px' }} />
                  <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>Generating your {dt.label} template for {jurisdiction}…</p>
                </div>
              )}

              {/* Form */}
              {docStep === 'form' && (
                <form onSubmit={handleGenerateDoc} style={{ maxWidth: '600px' }}>
                  <p style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '20px', lineHeight: 1.6 }}>
                    Fill in the details below. This will generate a document template — not a finalized legal document. Always have a qualified advocate review before filing.
                  </p>
                  {/* Jurisdiction selector */}
                  <div style={{ marginBottom: '20px', padding: '14px 16px', backgroundColor: 'rgba(251,191,36,0.06)', border: '1px solid rgba(251,191,36,0.2)', borderRadius: '10px' }}>
                    <label style={{ fontSize: '11px', fontWeight: 600, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.07em', display: 'block', marginBottom: '8px' }}>Jurisdiction</label>
                    <select
                      value={jurisdiction}
                      onChange={e => setJurisdiction(e.target.value)}
                      style={{ width: '100%', padding: '10px 13px', borderRadius: '8px', border: '1px solid var(--border)', backgroundColor: 'var(--bg-secondary)', color: 'var(--text-primary)', fontSize: '13px', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', cursor: 'pointer' }}
                    >
                      {JURISDICTION_OPTIONS.map(j => <option key={j} value={j}>{j}</option>)}
                    </select>
                    {jurisdiction !== 'Andhra Pradesh High Court' && jurisdiction !== 'Telangana High Court' && (
                      <p style={{ fontSize: '11px', color: 'var(--text-secondary)', margin: '8px 0 0', lineHeight: 1.5 }}>
                        A general Indian legal format will be used. Have it reviewed by a local advocate familiar with {jurisdiction} court practices.
                      </p>
                    )}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                    {dt.fields.map(field => (
                      <div key={field.key}>
                        <label style={lStyle}>{field.label}</label>
                        {field.type === 'textarea' ? (
                          <textarea
                            style={{ ...iStyle, height: '80px', resize: 'vertical' }}
                            placeholder={field.placeholder}
                            value={docFields[field.key] || ''}
                            onChange={e => setDocFields(f => ({ ...f, [field.key]: e.target.value }))}
                          />
                        ) : field.type === 'select' ? (
                          <select
                            style={{ ...iStyle, cursor: 'pointer' }}
                            value={docFields[field.key] || ''}
                            onChange={e => setDocFields(f => ({ ...f, [field.key]: e.target.value }))}
                          >
                            <option value="">Select…</option>
                            {field.options.map(o => <option key={o} value={o}>{o}</option>)}
                          </select>
                        ) : (
                          <input
                            style={iStyle}
                            placeholder={field.placeholder}
                            value={docFields[field.key] || ''}
                            onChange={e => setDocFields(f => ({ ...f, [field.key]: e.target.value }))}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                  {docError && <p style={{ fontSize: '13px', color: '#EF4444', margin: '12px 0 0' }}>{docError}</p>}
                  <button type="submit" style={{ marginTop: '20px', width: '100%', padding: '12px', borderRadius: '9px', background: 'var(--accent)', color: 'white', border: 'none', fontSize: '14px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
                    Generate {dt.label} template →
                  </button>
                </form>
              )}

              {/* Result */}
              {docStep === 'result' && docResult && (
                <div style={{ maxWidth: '700px' }}>
                  <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                    <button
                      onClick={() => downloadLegalDoc(docResult)}
                      style={{ background: 'linear-gradient(135deg,var(--accent),var(--accent))', color: '#fff', border: 'none', borderRadius: '8px', padding: '9px 18px', fontSize: '13px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}
                    >Download as PDF ↓</button>
                    <button
                      onClick={() => { navigator.clipboard.writeText(docResult).then(() => { setDocCopied(true); setTimeout(() => setDocCopied(false), 2000); }); }}
                      style={{ background: 'transparent', border: `1px solid ${docCopied ? '#10B981' : 'var(--border)'}`, borderRadius: '8px', padding: '9px 18px', fontSize: '13px', fontWeight: 600, color: docCopied ? '#10B981' : 'var(--text-secondary)', cursor: 'pointer', fontFamily: 'inherit', transition: 'all 0.2s' }}
                    >{docCopied ? '✓ Copied' : 'Copy text'}</button>
                  </div>
                  <div style={{ backgroundColor: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: '12px', padding: '28px 32px' }}>
                    <pre style={{ fontSize: '13px', color: 'var(--text-primary)', lineHeight: 1.85, margin: 0, whiteSpace: 'pre-wrap', fontFamily: 'Georgia, "Times New Roman", serif' }}>{docResult}</pre>
                  </div>
                  <p style={{ fontSize: '11px', color: 'var(--text-tertiary)', marginTop: '12px', lineHeight: 1.6 }}>
                    This is a starting template, not a finalized legal document. Have a qualified advocate review before filing.
                  </p>
                </div>
              )}
            </div>
          </div>
        );
      })()}

      {/* ── Chat area ── */}
      <div style={{ flex: 1, flexDirection: 'column', height: 'calc(100vh - 64px)', overflow: 'hidden', display: docType ? 'none' : 'flex' }}>

        {/* Error bar */}
        {legalChatError && (
          <div style={{ padding: '10px 24px', backgroundColor: 'rgba(244,63,94,0.12)', borderBottom: '1px solid rgba(244,63,94,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
            <span style={{ color: '#FB7185', fontSize: '13px', fontWeight: 500 }}>{legalChatError}</span>
            <button onClick={() => setLegalChatError('')} style={{ background: 'none', border: 'none', color: '#FB7185', cursor: 'pointer', fontSize: '16px', lineHeight: 1, padding: '0 4px', fontFamily: 'inherit' }}>×</button>
          </div>
        )}

        {/* Messages */}
        <div ref={legalChatRef} style={{ flex: 1, overflowY: 'auto', padding: '32px 40px', display: 'flex', flexDirection: 'column', gap: '16px' }}>

          {/* Loading conversation */}
          {legalMessagesLoading && (
            <div style={{ textAlign: 'center', marginTop: '80px', color: '#4B6279', fontSize: '14px' }}>Loading conversation...</div>
          )}

          {/* Empty state with suggestions */}
          {!legalMessagesLoading && legalMessages.length === 0 && (
            <div style={{ textAlign: 'center', marginTop: '80px' }}>
              <div style={{ width: '56px', height: '56px', borderRadius: '14px', background: 'rgba(139,92,246,0.12)', border: '1px solid rgba(139,92,246,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                <span style={{ color: 'var(--accent)', fontSize: '22px', fontWeight: 700, lineHeight: 1, fontFamily: 'Georgia, serif' }}>&sect;</span>
              </div>
              <p style={{ color: '#4B6279', fontSize: '15px', marginBottom: '8px' }}>Understand your legal rights — educational information on Indian law</p>
              <p style={{ color: '#2D3F55', fontSize: '13px', marginBottom: '24px' }}>GST, employment contracts, rent agreements, property disputes, notices, and more</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxWidth: '460px', margin: '0 auto' }}>
                {[
                  'Do I need to register for GST if my turnover is below Rs.20 lakhs?',
                  'Can my employer enforce a non-compete clause after I resign in India?',
                  'What should I check before signing a rent agreement in India?',
                ].map(q => (
                  <button key={q} onClick={() => handleLegalSend(null, q)}
                    style={{ padding: '10px 16px', borderRadius: '8px', border: '1px solid var(--border)', backgroundColor: 'var(--bg-secondary)', color: 'var(--text-secondary)', fontSize: '13px', cursor: 'pointer', textAlign: 'left', transition: 'border-color 0.2s, background-color 0.2s', fontFamily: 'inherit' }}
                    onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(139,92,246,0.4)'; e.currentTarget.style.backgroundColor = 'rgba(139,92,246,0.04)'; }}
                    onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.backgroundColor = 'var(--bg-secondary)'; }}
                  >{q}</button>
                ))}
              </div>
            </div>
          )}

          {/* First-time suggestion chips shown below the greeting message */}
          {!legalMessagesLoading && legalFirstTime && legalMessages.length === 1 && legalMessages[0]?.role === 'assistant' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxWidth: '460px' }}>
              {[
                'Do I need to register for GST if my turnover is below Rs.20 lakhs?',
                'Can my employer enforce a non-compete clause after I resign in India?',
                'What should I check before signing a rent agreement in India?',
              ].map(q => (
                <button key={q} onClick={() => handleLegalSend(null, q)}
                  style={{ padding: '10px 16px', borderRadius: '8px', border: '1px solid var(--border)', backgroundColor: 'var(--bg-secondary)', color: 'var(--text-secondary)', fontSize: '13px', cursor: 'pointer', textAlign: 'left', transition: 'border-color 0.2s, background-color 0.2s', fontFamily: 'inherit' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(139,92,246,0.4)'; e.currentTarget.style.backgroundColor = 'rgba(139,92,246,0.04)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.backgroundColor = 'var(--bg-secondary)'; }}
                >{q}</button>
              ))}
            </div>
          )}

          {!legalMessagesLoading && legalMessages.map((msg, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: msg.role === 'user' ? 'flex-end' : 'flex-start', flexDirection: 'column', alignItems: msg.role === 'user' ? 'flex-end' : 'flex-start' }}>
              <div style={{
                maxWidth: '72%', padding: '12px 16px',
                borderRadius: msg.role === 'user' ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
                backgroundColor: msg.role === 'user' ? 'var(--accent)' : 'var(--bg-secondary)',
                border: msg.role === 'user' ? 'none' : '1px solid var(--border)',
                color: 'var(--text-primary)', fontSize: '14px', lineHeight: 1.7, whiteSpace: 'pre-wrap',
              }}>{msg.text}</div>
              {msg.role === 'assistant' && msg.text.length > 80 && (
                <div style={{ display: 'flex', gap: '6px', marginTop: '5px', maxWidth: '72%' }}>
                  <button
                    onClick={() => copyMsg(msg.text, i)}
                    style={{ background: 'none', border: '1px solid var(--border)', borderRadius: '5px', color: copiedMsg === i ? '#10B981' : 'var(--text-tertiary)', fontSize: '11px', fontWeight: 600, padding: '3px 10px', cursor: 'pointer', fontFamily: 'inherit', transition: 'all 0.2s' }}
                    onMouseEnter={e => { if (copiedMsg !== i) e.currentTarget.style.borderColor = 'var(--text-tertiary)'; }}
                    onMouseLeave={e => { if (copiedMsg !== i) e.currentTarget.style.borderColor = 'var(--border)'; }}
                  >{copiedMsg === i ? '✓ Copied' : 'Copy'}</button>
                  {msg.text.length > 300 && (
                    <button
                      onClick={() => downloadLegalDoc(msg.text)}
                      style={{ background: 'none', border: '1px solid var(--border)', borderRadius: '5px', color: 'var(--accent)', fontSize: '11px', fontWeight: 600, padding: '3px 10px', cursor: 'pointer', fontFamily: 'inherit', transition: 'border-color 0.2s' }}
                      onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--accent)'}
                      onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border)'}
                    >Download as document ↓</button>
                  )}
                </div>
              )}
            </div>
          ))}
          {!legalMessagesLoading && legalLoading && (
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <div style={{ padding: '12px 18px', borderRadius: '16px 16px 16px 4px', backgroundColor: 'var(--bg-secondary)', border: '1px solid var(--border)', color: '#4B6279', fontSize: '14px' }}>Thinking...</div>
            </div>
          )}
        </div>

        {/* Disclaimer */}
        <p style={{ fontSize: '11px', color: 'var(--text-tertiary)', textAlign: 'center', padding: '6px', margin: 0, flexShrink: 0 }}>
          Educational information only — not legal advice. Consult a licensed advocate before taking any legal action.
        </p>

        {/* Input */}
        <div style={{ padding: '20px 40px', borderTop: '1px solid var(--border)', backgroundColor: 'var(--bg)' }}>
          <form onSubmit={handleLegalSend} style={{ display: 'flex', gap: '10px' }}>
            <input
              type="text"
              placeholder="Ask a legal question..."
              value={legalInput}
              onChange={e => setLegalInput(e.target.value)}
              disabled={legalLoading}
              style={{ flex: 1, padding: '13px 16px', borderRadius: '10px', border: '1px solid var(--border)', backgroundColor: 'var(--bg-secondary)', color: 'var(--text-primary)', fontSize: '14px', outline: 'none', fontFamily: 'inherit', opacity: legalLoading ? 0.6 : 1, transition: 'border-color 0.2s' }}
              onFocus={e => e.currentTarget.style.borderColor = 'var(--accent)'}
              onBlur={e => e.currentTarget.style.borderColor = 'var(--border)'}
            />
            <button type="submit" disabled={legalLoading || !legalInput.trim()}
              style={{ padding: '13px 22px', borderRadius: '10px', background: 'var(--accent)', color: 'white', border: 'none', fontWeight: 700, fontSize: '14px', cursor: legalLoading || !legalInput.trim() ? 'not-allowed' : 'pointer', opacity: legalLoading || !legalInput.trim() ? 0.5 : 1, transition: 'opacity 0.2s', whiteSpace: 'nowrap' }}
            >Send</button>
          </form>
        </div>
      </div>

      </div>{/* end flex row */}
    </section>
  );
};

export default LegalGPT;
